<template>
    <div class="page">
        <Breadcrumb title="平台设置" :breadcrumb="breadcrumb" />
        <div class="container">
            <h3-title :icon="h3Title.icon">{{ h3Title.title }}</h3-title>
            <div class="form">
                <el-form :model="formData" ref="formData" label-position="left" label-width="170px">
                    <el-form-item v-for="item of formList" :key="item.prop" :prop="item.prop" :rules="[{ required: !(item.required === false), message: '请输入' + item.label, trigger: 'blur' }]">
                        <span slot="label">{{ item.label }}<br />{{ item.tip }}</span>
                        <div class="content" v-if="item.type != 'upload'&&item.type != 'upload1'&&item.type != 'upload2'&&item.type != 'upload3'">
                            <el-input :type="item.type" v-model="formData[item.prop]" :placeholder="item.placeholder" class="form-input"></el-input>
                            <p class="info">{{ item.info }}</p>
                        </div>
                        <div class="content" style="min-height:60px" v-else>
                            <!-- <div v-if="item.type == 'upload'">
                                <input type="file" class="upload-file" :data-typeitem="item.prop" @change="handleUpFile" />
                                <div v-if="tag === 'add'" class="upload-btn">
                                    <i class="iconfont iconicon-test"></i>上传
                                    <span class="tip-file">{{ fileName ? fileName : '' }}</span>
                                </div>
                                <div v-else class="upload-btn">
                                    <i class="iconfont iconicon-test"></i>上传

                                    <span class="tip-file">{{
                  formData.keyPath != '' ? (formData.keyPath ? fileName : '未上传') : '未上传'
                }}</span>
                                </div>
                                <p class="info">{{ item.info }}</p>
                            </div> -->

                            <el-upload v-if="item.type == 'upload1'" :action="$configUrl.uploadZFB" multiple :limit="1" :on-exceed="handleExceed" :on-success="handleCertPath" :file-list="formData.certPath">
                                <el-button class="uploadBtn" size="medium" plain>+ 上传</el-button>
                            </el-upload>
                            <el-upload v-else-if="item.type == 'upload2'" :action="$configUrl.uploadZFB" multiple :limit="1" :on-exceed="handleExceed" :on-success="handleAlipayPublicCertPath" :file-list="formData.alipayPublicCertPath">
                                <el-button class="uploadBtn" size="medium" plain>+ 上传</el-button>
                            </el-upload>
                            <el-upload v-else-if="item.type == 'upload3'" :action="$configUrl.uploadZFB" multiple :limit="1" :on-exceed="handleExceed" :on-success="handleRootCertPath" :file-list="formData.rootCertPath">
                                <el-button class="uploadBtn" size="medium" plain>+ 上传</el-button>
                            </el-upload>
                            <!-- <div v-else class="upLoad" style="display:flex;justify-content:space-between;width:100%">
                                <el-upload :action="$configUrl.uploadZFB" :limit="1" :on-exceed="handleExceed" :on-success="handleSuccess" :file-list="[fileName]">
                                    <el-button class="uploadBtn" size="medium" plain>+ 上传</el-button>
                                </el-upload>
                                 <p class="info">{{ item.info }}</p>
                            </div> -->
                            <div v-else style="display:flex;justify-content:space-between;width:100%">
                                <input type="file" class="upload-file" @change="handleUpFile" />
                                <div v-if="tag === 'add'" class="upload-btn">
                                    <i class="iconfont iconicon-test"></i>上传
                                    <span class="tip-file">{{ fileName ? fileName : '' }}</span>
                                </div>
                                <div v-else class="upload-btn">
                                    <i class="iconfont iconicon-test"></i>上传
                                    <span class="tip-file">{{
                  formData.keyPath != '' ? (formData.keyPath ? fileName : '未上传') : '未上传'
                }}</span>
                                </div>
                                <p class="info">{{ item.info }}</p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label-width="0px">
                        <el-button type="primary" @click="submitForm('formData')">保存</el-button>
                        <el-button @click="resetForm">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { breadcrumb } from '@/mixins/index.js';
import { channel, setUpList, heepayChannel } from '@set-up/static/data.js';
import h3Title from '@set-up/components/h3-title';
import { mapActions, mapGetters, mapState } from 'vuex';
import OSS from 'ali-oss';
let client = new OSS({
  region: 'oss-cn-beijing',
  accessKeyId: 'LTAI4FwMYWcJsdYRTJEuSbya',
  accessKeySecret: 'GTKrBOaSbIEaaPBEJU94ETltZ08YuX',
  bucket: 'vueupdate',
});
export default {
  name: 'login',
  mixins: [breadcrumb],
  components: { h3Title },
  computed: {
    ...mapGetters('channel', ['mchDetail']),
    ...mapState('main', ['merchantInfo']),
  },
  data() {
    return {
      formData: {
        appId: '',
        appPrivateKey: '', //私钥
        keyPath: '', //证书地址
        subAppId: '', //服务商户的APPid
        subMchId: '', //服务商户的账号
        secret: '',
        payNotifyUrl: '', //成功回调地址
        appAuthToken: '',
        mchAccount: '', //商户号
        mchPublicKey: '', //公钥
        userId: '', //合作伙伴身份
        mchName: '', //三方商户简称
        certPath: [], //支付宝应用公钥证书
        alipayPublicCertPath: [], //支付宝公钥证书
        rootCertPath: [], //支付宝根证书
      },
      h3Title: {},
      formList: [],
      setUpList,
      channel,
      fileName: '', // 文件名
      tag: '',
      heepayChannel,
      fileList: [],
    };
  },
  watch: {
    formList() {
      if (this.$route.query.id && this.$route.query.id != 'heepay') {
        this.getDetailById({ id: this.$route.query.id }).then((res) => {
          res.wxPayParam.certPath = [res.wxPayParam.certPath];
          res.wxPayParam.alipayPublicCertPath = [res.wxPayParam.alipayPublicCertPath];
          res.wxPayParam.rootCertPath = [res.wxPayParam.rootCertPath];
          this.formData = res.wxPayParam;
          const filePathArr = res.wxPayParam.keyPath.split('/');
          this.fileName = filePathArr[filePathArr.length - 1];
        });
      } else if (this.$route.query.id && this.$route.query.id == 'heepay') {
        this.getMerchantInfo({ applyCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode }).then((res) => {
          this.formData = res;
        });
      }
    },
  },
  methods: {
    ...mapActions('main', ['getMerchantInfo']),
    ...mapActions('channel', ['addWechatJsapi', 'addHeepay', 'getDetailById', 'changeMchchan', 'editHeepay']),
    // 提交
    async submitForm(formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          if (this.tag) {
            if (this.$route.query.category === 'heepay') {
              this.creatHeepay();
            } else {
              this.createMch();
            }
          } else {
            if (this.$route.query.category === 'heepay') {
              this.editHee();
            } else {
              this.editMch();
            }
          }
        }
      });
    },
    editHee() {
      this.editHeepay(this.formData);
      this.$router.push({ name: 'setup/channel' });
    },
    // 新建---微信参数
    createMch() {
      var data = {
        applyCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode,
        chanCode: this.h3Title.category.toUpperCase(),
        chanId: '',
        merchantsMark: this.formData.mchAccount,
        type: this.h3Title.type,
        mchName: JSON.parse(localStorage.getItem('checkdApply')).applyName,
        wxPayParam: {
          appAuthToken: this.formData.appAuthToken,
          appId: this.formData.appId,
          appPrivateKey: this.formData.appPrivateKey,
          keyPath: this.formData.keyPath,
          mchAccount: this.formData.mchAccount,
          mchPublicKey: this.formData.mchPublicKey,
          payNotifyUrl: this.formData.payNotifyUrl,
          secret: this.formData.secret,
          subAppId: this.formData.subAppId,
          subMchId: this.formData.subMchId,
          userId: this.formData.userId,
          certPath: this.formData.certPath[0], //支付宝应用公钥证书
          alipayPublicCertPath: this.formData.alipayPublicCertPath[0], //支付宝公钥证书
          rootCertPath: this.formData.rootCertPath[0], //支付宝根证书
        },
      };
      this.addWechatJsapi(data).then((res) => {
        console.log(res);
        this.$message.success('新建成功');
        this.$router.push({ name: 'setup/channel' });
      });
    },
    // 新建---汇付宝参数
    async creatHeepay() {
      let data = {
        applyCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode, //应用code
        hyUid: this.formData.hyUid, //汇元uid
        hyLoginNumber: this.formData.hyLoginNumber, // 汇元商户登录号
        wxAppid: this.formData.wxAppid, //关联主体微信小程序appid
        hyApplyId: this.formData.hyApplyId, //汇元应用id
        applyChannel: 'HEEMONEY', //应用所属渠道
        hyApplyKey: this.formData.hyApplyKey, //汇元应用key
        relationDescribe: this.formData.relationDescribe, //描述
      };
      await this.addHeepay(data);
      await this.$router.push({ name: 'setup/channel' });
    },
    // 修改参数
    async editMch() {
      this.mchDetail.wxPayParam = this.formData;
      await this.changeMchchan(this.mchDetail);
      await this.$message.success('修改成功');
      await this.$router.push({ name: 'setup/channel' });
    },
    // 取消
    resetForm() {
      this.$router.go(-1);
    },
    // 上传文件
    async handleUpFile({
      target: {
        files: [file],
      },
    }) {
      const progress = async function (p) {
        console.log(p);
        //项目中需获取进度条，故调用进度回调函数（详见官方文档）
        // _this.$emit("getProgress", Math.round(p * 100));
        // _this.progress(Math.round(p * 100));
      };
      if (file) {
        const d = new Date();
        const str = d.getTime();
        const res = await client.multipartUpload(str + file.name, file, {
          progress,
          meta: {
            year: 2017,
            people: 'test',
          },
        });
        this.fileName = res.name;
        const fileUrl = res.res.requestUrls[0];
        this.formData.keyPath = fileUrl.substring(0, fileUrl.indexOf('?') + 1) || fileUrl;
        const filePathArr = this.formData.keyPath.split('/');
        this.formData.fileName = filePathArr[filePathArr.length - 1];
        console.log(this.fileName, '文件路径', this.formData.keyPath);
        console.log(this.formData, this.fileName);
      }
    },
    handleCertPath(res) {
      console.log(res);
      if (res.code == '1') {
        this.formData.certPath = [res.data];
      }
    },
    handleAlipayPublicCertPath(res) {
      if (res.code == '1') {
        this.formData.alipayPublicCertPath = [res.data];
      }
    },
    handleRootCertPath(res) {
      if (res.code == '1') {
        this.formData.rootCertPath = [res.data];
      }
    },
    handleExceed() {
      this.$message.warning(`只能上传一个文件`);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
  created() {
    let CHANNEL;
    if (this.$route.query.category === 'heepay') {
      CHANNEL = this.heepayChannel;
    } else {
      CHANNEL = this.channel;
    }
    this.h3Title = CHANNEL.get(this.$route.query.category).find((item) => {
      if (item.type == this.$route.query.type) {
        return item;
      }
    });
    let formList = this.setUpList.get(this.$route.query.category);
    if (this.h3Title.category === 'wechat') {
      if (this.h3Title.type !== 'JSGZHAPI') {
        this.formList = formList.slice(0, formList.length - 1);
      } else {
        this.formList = formList;
      }
    } else if (this.h3Title.category === 'alipay') {
      if (this.h3Title.type === 'TRANSFER') {
        this.formList = [...formList.slice(0, 2), ...formList.slice(3, 4), ...formList.slice(5, 8)];
      } else {
        this.formList = formList.slice(0, formList.length - 4);
      }
    }
    this.tag = !this.$route.query.id ? 'add' : '';
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
// 重写子组件样式
/deep/.h3 {
  font-size: 20px;
  .img {
    margin-right: 0.7em;
  }
}
// 重写 element-ui 样式
/deep/.el-form-item__label {
  line-height: 1.5em;
}
.content {
  display: flex;
  justify-content: space-between;
  .info {
    width: 406px;
    margin: 0;
    color: @font-color-info;
    line-height: 18px;
    font-size: @base-font-size;
  }
  .form-input {
    width: 300px;
  }
}
.content-fees .form-input {
  margin-top: 5px;
}
.page {
  height: 100%;
  .box_column();
}
.container {
  flex: 1;
  background-color: @bg-white;
  padding: 17px 49px 40px 20px;
  .form {
    margin-top: 2em;
  }
}
.upload-btn {
  width: 79px;
  height: 40px;
  text-align: center;
  color: #4359b7;
  border: 1px solid #4359b7;
  border-radius: 3px;
  font-size: 14px;
}
.upload-file {
  width: 60px;
  height: 30px;
  position: absolute;
  top: -4px;
  left: 9px;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}
.tip-file {
  display: inline-block;
  width: 300px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #707070;
  font-size: 12px;
}
/deep/.el-switch {
  vertical-align: top;
}
.uploadBtn {
  border-color: #4359b7;
  color: #4359b7;
}
</style>
